module.exports = __webpack_public_path__ + "fonts/Rk90BuTW.woff2";